import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

function Navbar({ activeSection, onContactClick }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (sectionId) => {
    if (location.pathname === '/') {
      // If on home page, scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on other page, navigate to home with hash
      navigate('/#' + sectionId);
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-brand">
          GSC INDIA Farms
        </Link>
        <ul className="nav-links">
          <li><Link to="/" className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}>Home</Link></li>
          <li><Link to="/about" className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}>About Us</Link></li>
          <li><button onClick={() => handleNavigation('services')} className={`nav-link ${activeSection === 'services' ? 'active' : ''}`}>What We Do</button></li>
          <li><button onClick={() => handleNavigation('feed')} className={`nav-link ${activeSection === 'feed' ? 'active' : ''}`}>Feed Formulation</button></li>
          <li><button onClick={onContactClick} className="nav-contact-btn">Contact Us</button></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
